<template>
    <div>
        <do-not-contact-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addDoNotContact">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </do-not-contact-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import DoNotContactTable from '../../components/do-not-contact/table';
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';

  export default {
    components: {
      DoNotContactTable,
      DialogFormWrapper,
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @event show-add-campaign-template-dialog
       */
      addDoNotContact() {
        eventBus.$emit('show-add-do-not-contact-dialog', this.createUrl);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      }
    },

    created() {
      eventBus.$on('refresh-do-not-contact-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-do-not-contact-table', this.refresh);
    }
  }
</script>
